import getStore from '../data/store/store';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';

let currentState = null;
let initialState = null;
/**
 * Utility function to log the usage of options.
 */
export default function logDataOnSaveAutomaticReplies() {
    currentState = getStore().currentState;
    initialState = getStore().initialState;
    if (!currentState) {
        return;
    }
    logIsAutomaticReplyEnabled();
    logIsTimePeriodEnabled();
    logIsBlockCalendarEnabled();
    logIsAutomaticallyDeclineNewEventsEnabled();
    logIsAutomaticallyDeclineExistingEventsEnabled();
    logDeclinedEventCount();
}

function logIsAutomaticReplyEnabled() {
    if (
        currentState.isAutomaticReplyEnabled != null &&
        currentState.isAutomaticReplyEnabled != initialState.isAutomaticReplyEnabled
    ) {
        const customData = datapoints.AutomaticRepliesOnOffStatus.datapoint.customData(
            currentState.isAutomaticReplyEnabled
        );
        logUsage(datapoints.AutomaticRepliesOnOffStatus.datapoint.name, customData);
    }
}

function logIsTimePeriodEnabled() {
    if (
        currentState.periodicReplyEnabled != null &&
        currentState.periodicReplyEnabled != initialState.periodicReplyEnabled
    ) {
        const customData = datapoints.AutomaticRepliesTimePeriodEnabled.datapoint.customData(
            currentState.periodicReplyEnabled
        );
        logUsage(datapoints.AutomaticRepliesTimePeriodEnabled.datapoint.name, customData);
    }
}

function logIsBlockCalendarEnabled() {
    if (
        currentState.blockCalendarEnabled != null &&
        currentState.blockCalendarEnabled != initialState.blockCalendarEnabled
    ) {
        const customData = datapoints.AutomaticRepliesBlockCalendarEnabled.datapoint.customData(
            currentState.blockCalendarEnabled
        );
        logUsage(datapoints.AutomaticRepliesBlockCalendarEnabled.datapoint.name, customData);
    }
}

function logIsAutomaticallyDeclineNewEventsEnabled() {
    if (
        currentState.declineNewInvitationsEnabled != null &&
        currentState.declineNewInvitationsEnabled != initialState.declineNewInvitationsEnabled
    ) {
        const customData = datapoints.AutomaticRepliesDeclineNewEnabled.datapoint.customData(
            currentState.declineNewInvitationsEnabled
        );
        logUsage(datapoints.AutomaticRepliesDeclineNewEnabled.datapoint.name, customData);
    }
}

function logIsAutomaticallyDeclineExistingEventsEnabled() {
    if (
        currentState.declineExistingCalendarEventsEnabled != null &&
        currentState.declineExistingCalendarEventsEnabled !=
            initialState.declineExistingCalendarEventsEnabled
    ) {
        const customData = datapoints.AutomaticRepliesDeclineExistingEnabled.datapoint.customData(
            currentState.declineExistingCalendarEventsEnabled
        );
        logUsage(datapoints.AutomaticRepliesDeclineExistingEnabled.datapoint.name, customData);
    }
}

function logDeclinedEventCount() {
    let store = getStore();
    if (store.selectedCalendarIds !== null && store.selectedCalendarIds.length > 0) {
        const customData = datapoints.AutomaticRepliesDeclinedEventsCountInfo.datapoint.customData(
            store.selectedCalendarIds.length
        );
        logUsage(datapoints.AutomaticRepliesDeclinedEventsCountInfo.datapoint.name, customData);
    }
}
